import { ref, computed } from 'vue'

// Sentinel value for "no sector" filter option
export const NO_SECTOR = '__no_sector__'

// Toggle order: none -> excluded (red) -> included (orange) -> none
export function useTriStateFilter() {
  const included = ref<string[]>([])
  const excluded = ref<string[]>([])

  function toggle(value: string) {
    if (included.value.includes(value)) {
      // included -> none
      included.value = included.value.filter((v) => v !== value)
    } else if (excluded.value.includes(value)) {
      // excluded -> included
      excluded.value = excluded.value.filter((v) => v !== value)
      included.value = [...included.value, value]
    } else {
      // none -> excluded
      excluded.value = [...excluded.value, value]
    }
  }

  function remove(value: string) {
    included.value = included.value.filter((v) => v !== value)
    excluded.value = excluded.value.filter((v) => v !== value)
  }

  function clear() {
    included.value = []
    excluded.value = []
  }

  const hasFilters = computed(() => included.value.length > 0 || excluded.value.length > 0)

  return {
    included,
    excluded,
    toggle,
    remove,
    clear,
    hasFilters,
  }
}
